import React, { useEffect, useLayoutEffect, useState, useContext, useRef } from 'react';
import { AppContext } from '../../context/AppContext.jsx';
import axios from 'axios';
import { useLanguage } from "../../i18n/LanguageContext.jsx";
import i18n from "../../i18n/i18n"; 
import { Link } from 'react-router-dom';

const InfoHpTemplate = ({ itemId, pageTitle }) => {
    const { language } = useLanguage();
    const [page, setPage] = useState(null);
    const [articles, setArticles] = useState(null);
    const [componentLoaded, setComponentLoaded] = useState(false);
    const { siteMap } = useContext(AppContext);
    const [isVideoPlaying, setIsVideoPlaying] = useState(true);

    const pageUrl = `/${language}${process.env.REACT_APP_API_PAGE_URL}`;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${pageUrl}/${itemId}`);
                setPage(res.data);
                //console.log("Info Home Page", res.data);
            } catch (error) {
                //console.error('Errore durante il fetchla pagina:', error);
            }
        };
        fetchData();
    }, [pageUrl, itemId]);

    useEffect(() => {
        if (page && siteMap) {
            setComponentLoaded(true);
        } else {
            setComponentLoaded(false);
        }
    }, [page, siteMap]);

    useEffect(() => {
        if (page && page.articles) {
            setArticles(page.articles);
        }
    }, [page]);



    return (
        <>
            {page && siteMap && (
                <div className="container-xl">
                    <div className="row justify-content-between">
                        {page.description && (
                            <div className="col-12 col-lg-4 col-xl-3 hr-right-lg">
                                <h2
                                    className="fs-1 br-lg lh-1"
                                    dangerouslySetInnerHTML={{ __html: page.description }}>
                                </h2>
                            </div>
                        )}
                        {page.text && (
                            <div className="col-12 col-lg-7 col-xl-8 mt-6 mt-lg-0">
                                <p
                                    className="fs-5 lh-sm font-secondary"
                                    dangerouslySetInnerHTML={{ __html: page.text }}
                                    data-animate-just-text>
                                </p>
                                <Link to={siteMap['d4a20e91-d00a-4f0f-96c3-691162743e41']?.path} className="font-secondary align-items-center bg-black btn d-flex justify-content-between px-4 rounded-0 text-uppercase text-white w-fitcontent mt-5">
                                    {i18n[language].discover}
                                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" className="ms-3" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.339111 0.367432L6.83911 6.36743L0.839111 12.3674" stroke="white" />
                                    </svg>
                                </Link> 
                            </div>
                        )} 
                    </div>
                </div>
            )}
        </>
    );
};

export default InfoHpTemplate; 